import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid default-dashboard" }
const _hoisted_2 = {
  class: "row",
  style: {"padding-right":"unset !important","justify-self":"center","width":"100%"}
}

import { RefSymbol } from "@vue/reactivity";
import { defineAsyncComponent, ref, onMounted, computed, watch, nextTick } from "vue";
import * as XLSX from "xlsx";



const SHEET_ID = "1bc6Ebg4QUd6Wf2BZVsMsvbgc0p4TfQdoMPT5eC7kGE0";


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const isMobile = ref(false);
const isNotMobile = ref(false);

const checkMobile = () => {
  isMobile.value = window.innerWidth < 1024;
};

const checkNotMobile = () => {
  isNotMobile.value = window.innerWidth >= 1024;
};

onMounted(() => {
  checkMobile();
  checkNotMobile();
  window.addEventListener("resize", checkMobile);
  window.addEventListener("resize", checkNotMobile);

});


const Map = defineAsyncComponent(
  () => import("@/components/theme/elder/Map.vue")
);
const SearchBar = defineAsyncComponent(
  () => import("@/components/theme/elder/SearchBar.vue")
);
const DataList = defineAsyncComponent(
  () => import("@/components/theme/elder/DataList.vue")
);

const provincesRaw = ref<
  { id: number; name: string; yearlyUsage: Record<string, number> }[]
>([]);

const selectedYear = ref("");
const filteredProvince = ref("");
const selectedProvinceObject = ref<{ id: number; name: string } | null>(null);

const searchBarRef = ref();

const handleProvinceChange = (provinceName: string) => {
  filteredProvince.value = provinceName;

  if (!provinceName) {
    searchBarRef.value?.provinceFilterRef?.resetSearchBar?.();
  }
};

const fetchDataForDownload = async (
  yearFilter: string,
  provinceFilter: string
) => {
  const recordQuery =
    "SELECT A, B, C, CC, CD, CE, CF, CG, CH, CI, CJ, CK, CL, CM, CN, CO, CP, CQ, CR, CS, CT, CU, CV, CW, CX, CY, CZ, DA, DB, DC, DD, DE, DF, DG";
  const recordUrl = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json&tq=${encodeURIComponent(
    recordQuery
  )}&sheet=ข้อมูลทั้งหมด`;

  try {
    const res = await fetch(recordUrl);
    const text = await res.text();
    const jsonData = JSON.parse(text.substring(47, text.length - 2));

    let caseData = jsonData.table.rows.map((row) => ({
      timestamp: row.c[0]?.v || "N/A",
      ปีที่บันทึก: row.c[0]?.v?.match(/\d{4}/)?.[0] || "-",
      จังหวัด: row.c[1]?.v?.trim() || "-",
      อำเภอ: row.c[2]?.v?.trim() || "-",
      อายุ: row.c[3]?.v || "-",
      เพศ: row.c[4]?.v?.trim() || "-",
      เหตุการณ์ที่ทำให้หกล้ม: row.c[5]?.v?.trim() || "-",
      ช่วงเวลาที่หกล้ม: row.c[6]?.v?.trim() || "-",
      บริเวณที่หกล้ม:
        row.c[7]?.v?.trim() +
        " : " +
        (row.c[8]?.v?.trim() || row.c[9]?.v?.trim() || "-"),
      กิจกรรมที่ทำขณะหกล้ม: row.c[10]?.v?.trim() || "-",
      การพักอาศัยของผู้สูงอายุ: row.c[11]?.v?.trim() || "-",
      โรคประจำตัว: row.c[13]?.v?.trim() || "-",
      ยาที่ได้รับ: row.c[14]?.v?.trim() || "-",
      การมองเห็น: row.c[15]?.v?.trim() || "-",
      "ยืนต่อเท้าเป็นเส้นตรง 10 วินาที": row.c[16]?.v?.trim() || "-",
      "การลุก นั่ง ยืน เดินไปและกลับ(6เมตร)": row.c[17]?.v?.trim() || "-",
      ใช้อุปกรณ์ช่วยเดินหรือไม่: row.c[18]?.v?.trim() || "-",
      "เคยล้มในช่วง 6 เดือนที่ผ่านมา": row.c[19]?.v?.trim() || "-",
      อาการบาดเจ็บหลังหกล้ม: row.c[21]?.v?.trim() || "-",
      "ได้ไปโรงพยาบาลหรือไม่ (กรณีที่ได้รับบาดเจ็บ)":
        row.c[22]?.v?.trim() || "-",
      "ไปโรงพยาบาลอย่างไร (กรณีที่ได้ไปโรงพยาบาล)": row.c[23]?.v?.trim() || "-",
      "นอนโรงพยาบาลหรือไม่ (กรณีที่ได้รับบาดเจ็บ)": row.c[24]?.v?.trim() || "-",
      "รายละเอียดการรักษา (กรณีที่ได้นอนโรงพยาบาล)":
        row.c[25]?.v?.trim() || "-",
      "การฟื้นฟูภายหลังจากพลัดตกหกล้ม (กายภาพบำบัด)":
        row.c[26]?.v?.trim() || "-",
      "แผนในการปรับปรุง แก้ไขบริเวณ (จุดเสี่ยง) ที่เกิดการพลัดตกหกล้ม":
        row.c[28]?.v?.trim() || "-",
      ต้องการคำแนะนำในการป้องกันการพลัดตกหกล้มหรือไม่:
        row.c[29]?.v?.trim() || "-",
      "ช่องทางการรับคำแนะนำ (กรณีที่ต้องการคำแนะนำ)":
        row.c[30]?.v?.trim() || "-",
      เบอร์โทรศัพท์: row.c[31]?.v?.trim() || "-",
      อีเมล: row.c[32]?.v?.trim() || "-",
      ผู้รายงาน: row.c[33]?.v?.trim() || "-",
    }));

    if (yearFilter) {
      caseData = caseData.filter((entry) => entry.ปีที่บันทึก === yearFilter);
    }

    if (provinceFilter) {
      caseData = caseData.filter((entry) => entry.จังหวัด === provinceFilter);
    }

    caseData.sort(
      (a, b) =>
        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    );

    return caseData;
  } catch (err) {
    console.error("❌ Error fetching data:", err);
    return [];
  }
};

const exportToExcel = async (yearFilter: string, provinceFilter: string) => {
  const data = await fetchDataForDownload(yearFilter, provinceFilter);

  if (data.length === 0) {
    alert("❌ ไม่มีข้อมูลให้ดาวน์โหลด");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Response Data");

  let filename = "ข้อมูลทั้งหมด.xlsx";
  if (yearFilter && provinceFilter)
    filename = `ข้อมูลในปี${yearFilter}_จังหวัด${provinceFilter}.xlsx`;
  else if (yearFilter) filename = `ข้อมูลในปี${yearFilter}.xlsx`;
  else if (provinceFilter) filename = `ข้อมูลในจังหวัด${provinceFilter}.xlsx`;

  XLSX.writeFile(workbook, filename);
};

onMounted(() => {
  window.addEventListener("trigger-download", (event: Event) => {
    exportToExcel(selectedYear.value, filteredProvince.value);
  });
});

const displayedData = computed(() => {
  const result = provincesRaw.value.map((prov) => {
    let count = 0;
    if (selectedYear.value) {
      count = prov.yearlyUsage[selectedYear.value] ?? 0;
    } else {
      count = Object.values(prov.yearlyUsage).reduce((acc, c) => acc + c, 0);
    }

    return {
      name: prov.name,
      count,
    };
  });

  return result;
});

watch(filteredProvince, (newName) => {
  if (!newName) {
    selectedProvinceObject.value = null;
    return;
  }

  const matched = provincesRaw.value.find((p) => p.name === newName);
  if (matched) {
    selectedProvinceObject.value = { id: matched.id, name: matched.name };
  }
});

const mapRef = ref();

const handleMapSelect = (provinceName: string) => {
  filteredProvince.value = provinceName;

  const matched = provincesRaw.value.find((p) => p.name === provinceName);
  if (matched) {
    selectedProvinceObject.value = { id: matched.id, name: matched.name };
  }
};


watch(selectedProvinceObject, (val) => {
  if (!val) {
    mapRef.value?.resetZoom();
  }
});

const dataListRef = ref();

const handleClearProvince = () => {
  filteredProvince.value = "";
  selectedProvinceObject.value = null;
  dataListRef.value?.resetView?.();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(checkNotMobile ? '' : 'row'),
      style: {"padding-right":"unset !important","justify-self":"center","width":"100%"}
    }, [
      _createVNode(_unref(SearchBar), {
        ref_key: "searchBarRef",
        ref: searchBarRef,
        onUpdateYear: _cache[0] || (_cache[0] = ($event: any) => (selectedYear.value = $event)),
        onUpdateProvinceFilter: _cache[1] || (_cache[1] = ($event: any) => (filteredProvince.value = $event)),
        onClearProvinceSelection: handleClearProvince
      }, null, 512),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Map), {
          ref_key: "mapRef",
          ref: mapRef,
          provinceData: displayedData.value,
          selectedProvince: filteredProvince.value,
          onSelectProvince: handleMapSelect,
          class: _normalizeClass(isMobile.value 
        ? 'col-12' 
        : 'col-md-6 col-lg-6 col-xl-6 col-xxl-6'),
          style: _normalizeStyle(isMobile.value 
        ? 'margin-bottom: 8px; margin-top: 8px;' 
        : '')
        }, null, 8, ["provinceData", "selectedProvince", "class", "style"]),
        _createVNode(_unref(DataList), {
          ref_key: "dataListRef",
          ref: dataListRef,
          selectedYear: selectedYear.value,
          filteredProvince: filteredProvince.value,
          selectedProvinceObject: selectedProvinceObject.value,
          onUpdateProvince: handleProvinceChange,
          onUpdateProvinces: _cache[2] || (_cache[2] = ($event: any) => (provincesRaw.value = $event)),
          class: _normalizeClass(isMobile.value 
        ? 'col-12' 
        : 'col-md-6 col-lg-6 col-xl-6 col-xxl-6'),
          style: _normalizeStyle(isMobile.value 
        ? ' margin-top: 8px;' 
        : '')
        }, null, 8, ["selectedYear", "filteredProvince", "selectedProvinceObject", "class", "style"])
      ])
    ], 2)
  ]))
}
}

})